/* eslint-disable eqeqeq */
/* eslint-disable vue/require-v-for-key */
<template>
  <!-- 质检任务 -->
  <div class="max_box">
    <!-- top -->
    <div class="top_box"><span class="top_span">实时质检报表</span></div>
    <!-- query -->
    <span>
      <span class="item_font">统计项</span>
      <el-select v-model="form.timeDim"
                 size="small"
                 placeholder="请选择"
                 style="width:80px;"
                 @change="changeDate">
        <el-option v-for="item in timeDim_options"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
    </span>
    <span class="item_position">
      <span class="item_font">时间维度</span>
      <el-date-picker size="small"
                      style="width: 16%;"
                      v-model="form.selectTime"
                      :type="date_type"
                      @change="timeFormat"
                      :clearable="clearable"
                      :picker-options="picker_options"
                      :format="formatt"
                      :value-format="formatTime">
      </el-date-picker>
    </span>
    <span class="item_position">
      <el-select filterable
                 v-model="form.skillGroup"
                 size="small"
                 style="width: 15%;"
                 @change="changeSeatsGroup">
        <el-option key="all"
                   label="所有技能组"
                   value="all"></el-option>
        <el-option v-for="item in skillGroup_options"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
        </el-option>
      </el-select>
    </span>
    <span class="item_position">
      <el-select filterable
                 v-model="form.seatsId"
                 size="small"
                 style="width: 15%;">
        <el-option key="all"
                   label="所有坐席"
                   value="all"></el-option>
        <el-option v-for="item in seats_options"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
        </el-option>
      </el-select>
    </span>
    <span class="item_position">
      <el-button icon="el-icon-search"
                 size="small"
                 @click="search">查询</el-button>
    </span>
    <!-- table -->
    <el-table class="table_box_el_table"
              tooltip-effect="light"
              placement="top"
              :data="sessionLogTableData"
              @filter-change="filterChange"
              v-loading="load_table">
      <el-table-column label="序号"
                       align="center"
                       type="index"
                       :index="indexMethod"
                       width="60"></el-table-column>
      <el-table-column label="访客进入时间"
                       align="center"
                       :show-overflow-tooltip="true"
                       min-width="120">
        <template slot-scope="scope">
          <span class="table_span">{{ scope.row.startTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="坐席"
                       align="center"
                       :show-overflow-tooltip="true"
                       min-width="80">
        <template slot-scope="scope">
          <span class="table_span">{{scope.row.agent.name || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="会话开始时间"
                       align="center"
                       :show-overflow-tooltip="true"
                       min-width="120">
        <template slot-scope="scope">
          <span class="table_span">{{ scope.row.startTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="会话结束时间"
                       align="center"
                       :show-overflow-tooltip="true"
                       min-width="120">
        <template slot-scope="scope">
          <span class="table_span">{{ scope.row.endTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="会话时长"
                       align="center"
                       min-width="100"
                       :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span class="table_span">{{sessionTime(scope.row.startTime,scope.row.endTime)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="告警次数"
                       align="center"
                       :show-overflow-tooltip="true"
                       min-width="80">
        <template slot-scope="scope">
          <span class="table_span">{{ scope.row.warnNum }}</span>
        </template>
      </el-table-column>
      <el-table-column label="会话ID"
                       align="center"
                       :show-overflow-tooltip="true"
                       min-width="100">
        <template slot-scope="scope">
          <span class="table_span">{{ scope.row.sessionId }}</span>
        </template>
      </el-table-column>
      <el-table-column label="会话结束原因"
                       align="center"
                       v-if="tableShow.endReason"
                       :show-overflow-tooltip="true"
                       min-width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.endReason"
                class="table_span">{{ scope.row.endReason }}</span>
          <span v-if="!scope.row.endReason"
                class="table_span">--</span>
        </template>
      </el-table-column>
      <el-table-column label="咨询分类"
                       align="center"
                       v-if="tableShow.consultationType"
                       :show-overflow-tooltip="true"
                       min-width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.consultationType"
                class="table_span">{{ scope.row.consultationType }}</span>
          <span v-if="!scope.row.consultationType"
                class="table_span">--</span>
        </template>
      </el-table-column>
      <el-table-column label="满意度"
                       align="center"
                       v-if="tableShow.satisfaction"
                       :show-overflow-tooltip="true"
                       min-width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.satisfaction"
                class="table_span">{{ scope.row.satisfaction }}</span>
          <span v-if="!scope.row.satisfaction"
                class="table_span">--</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
              fixed="right"
              :filters="[{ text: '会话结束原因', value: '1' },{ text: '咨询分类', value: '2' }, { text: '满意度', value: '3' }]"
              :filter-multiple="true"
              :column-key="'columns'"
              label="操作"
              align="center"
              :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="查看" placement="top">
                  <el-button size="mini" @click="openDialog(scope.row.sessionId)" type="info" icon="el-icon-view" circle></el-button>
                  </el-tooltip>
                </template>
            </el-table-column> -->
      <el-table-column label="操作"
                       align="center"
                       :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-tooltip class="item"
                      effect="light"
                      content="查看"
                      placement="top">
            <el-button
                       @click="openDialog(scope.row.sessionId,scope.row.agent.id)"
                       type="text">
              <svg class="icon icon-bianji"
                   aria-hidden="true">
                <use xlink:href="#iconxiangqing" />
              </svg>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- page -->
    <Page v-bind:init_item="pageBuild"
          @currentPage="currentPage" />
    <!-- drawer -->
    <el-drawer title="会话详情"
               :before-close="cancelForm"
               :visible.sync="dialog"
               custom-class="demo-drawer"
               size="560px">
      <div class="bfb mdialog_box"
           style="max-height: 450px;min-height: 400px;">
        <div v-for="obj in chatLogList"
             :key="obj.id">
          <!-- 用户消息start -->
          <div name="messageList"
               v-if="obj.direction=='up'"
               :class="obj.defaultClass"
               :id="'row'+obj.cid">
            <div class="bfb left mdialog_datatxt">
              <span style="font-size:14px;padding-right:10px;color:#000;">{{obj.username}}</span>
              <span style="font-size:12px;">{{obj.createTime}}</span>
            </div>
            <div>
              <div class="mdialog_ico left">
                <p><span class="iconfont iconmenuicon-kehu"></span></p>
              </div>
              <div class="mdialog_txtbox left">
                <div class="bfb left">
                  <div v-if="obj.type=='text'"
                       class="mdialog_audio left mdialog_bg2 c444 pst">
                    <div class="mdialog_l"></div>
                    <div class="mdialog_txt left">
                      {{obj.msgContent.content}}
                    </div>
                  </div>
                  <div v-if="obj.type=='file'"
                       class="mdialog_audio left mdialog_bg2_file c444 pst"
                       style="background-color:#e4e4e4;">
                    <div class="mdialog_l"></div>
                    <div v-if="obj.msgContent.url.includes('/res/videos/')"
                         class="mdialog_txt left">
                      <div class="input_video">
                        <video-player class="video-player vjs-custom-skin"
                                      ref="videoPlayer"
                                      :playsinline="true"
                                      :options="obj.playerOptions"></video-player>
                      </div>
                    </div>
                    <div v-else
                         class="mdialog_txt left">
                      <el-link type="primary"
                               :href="obj.msgContent.url">{{obj.msgContent.name}} <i class="el-icon-download"></i></el-link>
                    </div>
                  </div>
                  <div v-if="obj.type=='image'"
                       class="mdialog_txt left">
                    <el-image :src="obj.msgContent.url"
                              style="width:200px;height:160px;"></el-image>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 用户消息end -->
          <!-- 客服消息start -->
          <div name="messageList"
               v-if="obj.direction=='down'"
               :class="obj.defaultClass"
               :id="'row'+obj.cid">
            <div class="bfb right tr mdialog_datatxt">
              <span style="font-size:12px;padding-left:10px;">{{obj.createTime}}</span>
              <span style="font-size:14px;color:#000;"> {{obj.agent.name}}</span>
            </div>
            <div class="mdialog_ico right">
              <p><span class="iconfont iconheadicon-zuoxi"></span></p>
            </div>
            <div class="mdialog_txtbox right">
              <div class="bfb right">
                <div v-if="obj.type=='text'"
                     class="mdialog_audio right mdialog_bg1 cfff pst">
                  <div class="mdialog_r"></div>
                  <div class="mdialog_txt right">
                    {{obj.msgContent.content}}
                  </div>
                </div>
                <div v-if="obj.type=='file'"
                     class="mdialog_audio right mdialog_bg1_file cfff pst"
                     style="background-color:white;">
                  <div class="mdialog_r"></div>
                  <div v-if="obj.msgContent.url.includes('/res/videos/')"
                       class="mdialog_txt right">
                    <div class="input_video">
                      <video-player class="video-player vjs-custom-skin"
                                    ref="videoPlayer"
                                    :playsinline="true"
                                    :options="obj.playerOptions"></video-player>
                    </div>
                  </div>
                  <div v-else
                       class="mdialog_txt right">
                    <el-link type="primary"
                             @click="chatLogDownloadFile(obj.msgContent.url,obj.msgContent.name)"
                             icon="el-icon-download">{{obj.msgContent.name}}</el-link>
                  </div>
                </div>
                <div v-if="obj.type=='image'"
                     class="mdialog_image right">
                  <el-image :src="obj.msgContent.url"
                            style="width:200px;height:160px;"></el-image>
                </div>
              </div>
            </div>
          </div>
          <!-- 客服消息end -->
        </div>
      </div>
      <div class="divider_div">实时质检项</div>
      <el-divider></el-divider>
      <el-table stripe
                size="small"
                :data="warnMsgTableData"
                style="width: 100%;margin-top:15px;overflow: auto;"
                max-height="360"
                min-height="200">
        <el-table-column type="index"
                         width="60"
                         label="序号">
        </el-table-column>
        <el-table-column label="警告用语/行为"
                         align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.ex1.length>0"
                  class="table_span">
              <el-popover popper-class="el-popover-qc"
                          placement="top"
                          width="280"
                          trigger="hover">
                <div class="popover-content"
                     style="width: 100%;text-align: center"
                     v-html="scope.row.ex1"></div>
                <span class="pointerClass"
                      slot="reference">{{scope.row.ex.length>6?scope.row.ex.substr(0,5)+'...':scope.row.ex}}
                  <i v-if="scope.row.ex1.length>0"
                     class="el-icon-warning-outline div_title_span_i"></i>
                </span>
              </el-popover>
            </span>
            <span v-else>
              {{scope.row.ex}}
            </span>

          </template>
        </el-table-column>
        <el-table-column label="质检项"
                         align="center"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span class="table_span">{{ scope.row.modelId }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         align="center"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tooltip class="item"
                        effect="dark"
                        content="定位"
                        placement="top">
              <el-button size="mini"
                         type="info"
                         icon="el-icon-aim"
                         @click="moveScoll(scope.row.id)"
                         circle></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>

<script>
import { getChatLogList, getSessionLogList, downloadFile } from '@/api/qc/realTimeReport'
import Page from '@/views/qc/public/PageComponent'
import { dateToString } from '@/views/qc//utils/dateUtils'
export default {
  name: 'qcRealTimeReport',
  components: {
    Page
  },
  data: function () {
    return {
      // 视频播放
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选择的播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: '',
          src: ''// url地址
        }],
        poster: '', // 你的封面地址  width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 全屏按钮
        }
      },
      form: {
        timeDim: '1',
        selectTime: dateToString(new Date(), 'yyyy-MM-dd'),
        skillGroup: 'all',
        seatsId: 'all'
      },
      seats_options: [],
      skillGroup_options: [],
      timeDim_options: [{
        value: '1',
        label: '时'
      }, {
        value: '2',
        label: '天'
      }, {
        value: '3',
        label: '月'
      }],
      picker_options: {
        disabledDate: (time) => {
          // 设置选择日期不能大于当前时间
          return time.getTime() >= Date.now()
        }
      },
      date_type: 'date',
      formatt: '',
      formatTime: 'yyyy-MM-dd',
      wrapperClosable: false,
      clearable: false,
      popoverWidth: '80%',
      table: false,
      dialog: false,
      loading: false,
      formLabelWidth: '80px',
      sessionLogTableData: [],
      chatLogList: [],
      warnMsgTableData: [],
      load_table: false,
      pageBuild: { // 分页与查询参数
        page_size: 10,
        total: 0,
        currentPage: 1,
        timeDim: '',
        selectTime: '',
        skillGroupIds: [],
        seatsId: ''
      },
      tableShow: {
        endReason: false,
        consultationType: false,
        satisfaction: false
      },
      defaultClass: 'bfb mdialog_div',
      activeClass: 'bfb mdialog_div activeClass',
      warnMessageStyle: '<span style="background:#F56C6C;color:#fff">'
    }
  },
  methods: {
    moveScoll (askId) {
      const that = this
      // eslint-disable-next-line no-unused-expressions
      var idstr = 'row' + askId
      var dom = document.getElementById('' + idstr)
      that.chatLogList.forEach(function (item, idx, arr) {
        // eslint-disable-next-line eqeqeq
        if (item.direction == 'up') { item.defaultClass = that.defaultClass + ' left' }
        // eslint-disable-next-line eqeqeq
        if (item.direction == 'down') { item.defaultClass = that.defaultClass + ' right' }
        // eslint-disable-next-line eqeqeq
        if (askId == item.cid && item.direction == 'up') { item.defaultClass = that.activeClass + ' left' }
        // eslint-disable-next-line eqeqeq
        if (askId == item.cid && item.direction == 'down') { item.defaultClass = that.activeClass + ' right' }
      })
      setTimeout(() => {
        dom.scrollIntoView()
      })
    },
    changeDate () {
      const now = new Date()
      this.form.selectTime = ''
      // eslint-disable-next-line eqeqeq
      if (this.form.timeDim == '1') {
        this.date_type = 'date'
        this.formatTime = 'yyyy-MM-dd'
        this.form.selectTime = dateToString(now, 'yyyy-MM-dd')
        // eslint-disable-next-line eqeqeq
      } else if (this.form.timeDim == '2') {
        this.date_type = 'month'
        this.formatTime = 'yyyy-MM'
        this.form.selectTime = dateToString(now, 'yyyy-MM')
        // eslint-disable-next-line eqeqeq
      } else if (this.form.timeDim == '3') {
        this.date_type = 'year'
        this.formatTime = 'yyyy'
        this.form.selectTime = dateToString(now, 'yyyy')
      }
    },
    timeFormat (val) {
      this.form.selectTime = val
    },
    cancelForm () { // 关闭弹出层
      this.loading = false
      this.dialog = false
    },
    openDialog (sessionId, seatId) { // 打开弹出层
      const that = this
      that.dialog = true
      getChatLogList({ sessionId: sessionId, seatId: seatId }).then(res => {
        var chatLogList = res.data.data[0]
        chatLogList.forEach(function (item, index, arr) {
          // eslint-disable-next-line eqeqeq
          if (item.type == 'file' && item.msgContent.url.includes('/res/videos/')) {
            that.playerOptions.sources[0].src = item.msgContent.url
            item.playerOptions = that.playerOptions
          }
          // eslint-disable-next-line eqeqeq
          if (item.direction == 'up') {
            item.defaultClass = that.defaultClass + ' left'
            // eslint-disable-next-line eqeqeq
          } else if (item.direction == 'down') {
            item.defaultClass = that.defaultClass + ' right'
          }
        })
        var warnMsgTableData = res.data.data[1]
        that.chatLogList = chatLogList
        that.warnMsgTableData = warnMsgTableData
      })
    },
    currentPage (currentPage) { // 分页跳转
      this.search(currentPage)
    },
    sessionTime (startTime, endTime) {
      var talkTimeStr = ''
      const time = (new Date(Date.parse(endTime.replace(/-/g, '/'))).valueOf() - new Date(Date.parse(startTime.replace(/-/g, '/'))).valueOf())
      const hours = parseInt((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = parseInt((time % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = (time % (1000 * 60)) / 1000
      // eslint-disable-next-line no-const-assign
      talkTimeStr = hours + '时' + minutes + '分' + seconds + '秒'
      return talkTimeStr
    },
    search (currentPage) { // 搜索任务
      const that = this
      const power = that.$qcAuthUtis.qcHasListAuth('aicc-qc', '103110')
      // eslint-disable-next-line eqeqeq
      // 仅可查看自己
      that.pageBuild.skillGroupIds = []
      that.pageBuild.seatsId = ''
      if (power.option === 'jkckzj') {
        that.skillGroup_options.forEach(function (item, index, array) {
          that.pageBuild.skillGroupIds.push(item.id)
        })
        that.pageBuild.seatsId = that.skillGroup_options[0].skillUsers[0].id
      } else if (power.option === 'zdykz' || power.option === 'ckssjnz') { // 查看自定义跨组和查看所属技能组
        // 如果选择全部
        // eslint-disable-next-line eqeqeq
        if (that.form.skillGroup == 'all') {
          for (var i = 0; i < that.skillGroup_options.length; i++) {
            that.pageBuild.skillGroupIds.push(that.skillGroup_options[i].id)
          }
        }
      }
      if (!that.pageBuild.seatsId) {
        // eslint-disable-next-line eqeqeq
        that.pageBuild.seatsId = that.form.seatsId == 'all' ? '' : that.form.seatsId
      }
      // eslint-disable-next-line eqeqeq
      if (that.pageBuild.skillGroupIds.length < 1 && that.form.skillGroup != 'all') {
        // eslint-disable-next-line eqeqeq
        that.pageBuild.skillGroupIds.push(that.form.skillGroup)
      }
      // that.load_table = true
      that.pageBuild.currentPage = typeof currentPage === 'number' ? currentPage : 1
      that.pageBuild.selectTime = that.form.selectTime
      that.pageBuild.timeDim = that.form.timeDim
      if (that.skillGroup_options.length > 0) {
        getSessionLogList(that.pageBuild).then(res => {
          that.sessionLogTableData = res.data.data.root
          that.pageBuild.total = res.data.data.totalProperty
          that.load_table = false
        })
      }
    },
    getCustomerGroupInfo () {
      const that = this
      that.skillGroup_options = []
      this.$qcAuthUtis.qcSkillGroupList('aicc-qc', '103110', function (res) {
        const data = res.data.data
        that.skillGroup_options = data
        that.changeSeatsGroup()
        that.search()
      })
    },
    changeSeatsGroup () {
      const that = this
      var strSeatIds = ''
      that.seats_options = []
      that.form.seatsId = 'all'
      that.skillGroup_options.forEach(function (item, index, arr) {
        // eslint-disable-next-line eqeqeq
        if (that.form.skillGroup == 'all' && item.skillUsers) { // 选择了所有坐席组，将所有坐席遍历到坐席选择框中
          item.skillUsers.forEach(function (obj, idx, array) {
            if (!strSeatIds.includes(obj.id)) { // 排除重复坐席
              // eslint-disable-next-line no-const-assign
              strSeatIds = strSeatIds + ',' + obj.id
              that.seats_options.push(obj)
            }
          })
        }
        // eslint-disable-next-line eqeqeq
        if (that.form.skillGroup == item.id) { // 选择了某个坐席组，将某个坐席组中的坐席遍历到坐席选择框中
          that.seats_options = item.skillUsers
        }
      })
    }, /**
     * 表格绑定条件改变时
     */
    filterChange: function (value) {
      var f = false
      if (f) {
        this.currentPage()
      }
      this.tableShow.consultationType = false
      this.tableShow.satisfaction = false
      this.tableShow.endReason = false
      if (value.columns && value.columns.length > 0) {
        for (var k = 0; k < value.columns.length; k++) {
          // eslint-disable-next-line eqeqeq
          if (value.columns[k] == 1) {
            this.tableShow.endReason = true
          }
          // eslint-disable-next-line eqeqeq
          if (value.columns[k] == 2) {
            this.tableShow.consultationType = true
          }
          // eslint-disable-next-line eqeqeq
          if (value.columns[k] == 3) {
            this.tableShow.satisfaction = true
          }
        }
      }
    },
    indexMethod (index) { // 任务table序号生成
      return index + 1 + this.pageBuild.page_size * (this.pageBuild.currentPage - 1)
    },
    chatLogDownloadFile (url, fileName) {
      downloadFile(url).then(res => {
        const blob = new Blob([res.data], { type: 'application/x-msdownload' })
        this.download(blob, fileName)
      })
    },
    download (blob, fileName) {
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else { // IE10+下载
        navigator.msSaveBlob(blob, fileName)
      }
    }
  },
  mounted () {
    this.getCustomerGroupInfo()
    this.changeDate()
  }
}
</script>

<style  scoped>
.max_box {
  width: 100%;
  /* height: 90%;
        overflow:auto; */
}
.top_box {
  width: 100%;
  border-bottom: #e1e3e6 solid 1px;
  padding-top: 12px;
  padding-bottom: 9px;
  margin-bottom: 20px;
}
.top_span {
  color: #222;
  font-size: 20px;
  padding-bottom: 10px;
  border-bottom: #0080fe solid 1px;
  padding-right: 5px;
}
.form_box {
  width: 100%;
  margin-bottom: 10px;
}
.form_label {
  font-size: 14px;
}
.form_input {
  width: 200px;
  margin-right: 20px;
}
.table_box_el_table {
  width: 100%;
  /*margin-top: 15px;*/
}
.table_span {
  margin-left: 5px;
}
.table_box_el_table
  >>> .el-table__body-wrapper
  > .el-table__body
  tbody
  tr
  .el-table_1_column_1
  .cell
  div {
  width: 22px !important;
  border-radius: 15px;
  background: #eee;
  margin-left: 2px;
}
/deep/.el-drawer {
  overflow: auto;
}
/deep/.el-drawer__header {
  font-size: 18px;
}
.el-drawer__wrapper >>> .el-drawer__header > span:focus {
  outline: 0px solid;
}
.el-table >>> thead tr th {
  background: #f1f1f1 !important;
  padding: 12px 5px !important;
  color: #777 !important;
}
/*.el-table >>> tbody tr td {
      padding: 12px 5px !important;
    }*/
/deep/.el-table td {
  text-align: center;
}
.divider_div {
  font-size: 16px;
  border-left: #337eff solid 3px;
  line-height: 14px;
  padding-left: 10px;
  margin-top: 15px;
}
.el-divider--horizontal {
  margin: 10px 0;
}
.el-button--info {
  background-color: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.el-drawer__wrapper >>> .el-drawer__header > span {
  font-size: 16px;
  border-left: #337eff solid 3px;
  line-height: 14px;
  padding-left: 10px;
}
.el-drawer__wrapper >>> .el-drawer__header {
  border-bottom: #e1e3e6 solid 1px;
  padding: 0px 0 10px 0;
  margin-bottom: 10px;
}
.el-drawer__wrapper >>> .el-drawer {
  padding: 20px;
}
.item_font {
  font-size: 14px;
  margin-right: 15px;
}
/deep/.el-input__inner {
  font-size: 12px;
}
.item_position {
  /*margin-top: 15px;*/
  margin-left: 10px;
  margin-bottom: 10px;
}
.item_position >>> .el-select,
    /*.item_position >>> .el-input,*/
    .item_position >>> .el-button {
  margin-bottom: 10px;
}
.item_position >>> .el-button {
  width: 80px;
  height: 32px;
  font-size: 12px;
}
.el-button--mini.is-circle {
  padding: 7px;
}
.el-button--info:hover {
  background-color: #4bbaff;
  color: #fff;
  border: 1px solid #4bbaff;
}
.activeClass {
  background-color: #fff0f5;
  border: #fff0f5 1px solid;
  padding-top: 10px;
  padding-bottom: 5px;
  border-radius: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.iconfont {
  padding: 6px;
  font-size: 23px !important;
  color: white;
}
.pointerClass:hover {
  cursor: help;
}
.div_title_span_i {
  color: #fab153;
  margin-left: 10px;
}
.input_video {
  width: 400px;
}
.el-input--prefix >>> .el-input__inner {
  padding-left: 30px !important;
}
.bfb {
  width: 100%;
}
.left {
  float: left;
}
.right {
  float: right;
}
.pst {
  position: relative;
}
.cfff {
  color: #fff;
}
.c444 {
  color: #444;
}
.tr {
  text-align: right;
}
.tl {
  text-align: left;
}
.modal-dialogbox {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0;
  bottom: 0;
}
.mdialog_box {
  max-height: 100%;
  overflow-y: auto;
  padding: 15px 0;
}
.mdialog_div {
  margin-bottom: 30px;
}
.mdialog_ico {
  width: 42px;
  height: 42;
}
.mdialog_ico p {
  width: 36px;
  height: 36px;
  margin: 0 auto;
  background-color: #6ec3ff;
  border-radius: 50%;
  overflow: hidden;
}
.mdialog_txtbox {
  min-width: 80px;
  max-width: 80%;
  width: auto;
  margin-right: 10px;
  margin-left: 10px;
}
.mdialog_datatxt {
  color: #999;
  line-height: 0px;
  padding-bottom: 15px;
  padding-left: 50px;
  padding-right: 50px;
}
.mdialog_audio {
  height: auto;
  line-height: 26px;
  padding: 5px 13px;
  border-radius: 8px;
  text-align: left;
}
.mdialog_txt {
  width: auto;
  border-radius: 2px;
  line-height: 18px;
  padding: 6px 8px;
  font-size: 12px;
  text-align: left;
}
.mdialog_image {
  width: auto;
  height: auto;
}
.mdialog_bg1 {
  background-color: #6ec3ff;
}
.mdialog_bg1_file {
  border: #6ec3ff 1px solid;
}
.mdialog_bg2 {
  background-color: #e4e4e4;
}
.mdialog_bg2_file {
  border: #e4e4e4 1px solid;
}
.mdialog_l {
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-right: 5px solid #e4e4e4;
  position: absolute;
  left: -5px;
  top: 10px;
}
.mdialog_r {
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 5px solid #6ec3ff;
  position: absolute;
  right: -5px;
  top: 10px;
}
</style>
